export interface SendKeyEvent {
    key: string;
    shiftKey: boolean;
    isComposing: boolean;
    keyCode: number;
}

// keyCode 229 is the legacy signal browsers still emit while an IME is composing.
const IME_COMPOSING_KEY_CODE = 229;

export function readSendOnEnter(storageKey: string, defaultValue: boolean): boolean {
    try {
        const raw = localStorage.getItem(storageKey);
        return raw === null ? defaultValue : raw === 'true';
    } catch {
        return defaultValue;
    }
}

export function writeSendOnEnter(storageKey: string, value: boolean): void {
    try {
        localStorage.setItem(storageKey, String(value));
    } catch {
        /* noop */
    }
}

export function isSendKeystroke(event: SendKeyEvent, sendOnEnter: boolean): boolean {
    if (event.key !== 'Enter') return false;
    if (event.isComposing || event.keyCode === IME_COMPOSING_KEY_CODE) return false;
    return sendOnEnter ? !event.shiftKey : event.shiftKey;
}

export function withSendKeyHint(placeholder: string, sendOnEnter: boolean): string {
    return sendOnEnter
        ? `${placeholder} (Shift+Enter for new line)`
        : `${placeholder} (Shift+Enter to send)`;
}

export function sendKeyToggleLabel(sendOnEnter: boolean): string {
    return sendOnEnter
        ? 'Enter sends. Click to switch to Shift+Enter.'
        : 'Shift+Enter sends. Click to switch to Enter.';
}
